import { c as _c } from "react/compiler-runtime";
import * as Popover from '@radix-ui/react-popover';
import type React from 'react';
type ComboRootProps = {
  children: React.ReactNode;
  open: boolean;
  onOpenChange: (open: boolean) => void;
};
const ComboRoot = t0 => {
  const $ = _c(4);
  const {
    children,
    open,
    onOpenChange
  } = t0;
  let t1;
  if ($[0] !== children || $[1] !== onOpenChange || $[2] !== open) {
    t1 = <Popover.Root open={open} onOpenChange={onOpenChange}>{children}</Popover.Root>;
    $[0] = children;
    $[1] = onOpenChange;
    $[2] = open;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};
export default ComboRoot;